import React, {PropsWithChildren} from "react";
import {Colors, Container, Text} from "../../../../ui";
import {IconAlertOutlined, NotificationCard} from "../../../bounce-ui";
import {PaymentType} from "../../../declarations";

interface OneCentAuthorizationLabelProps extends PropsWithChildren<any> {
  type: PaymentType;
}

export const OneCentAuthorizationLabel = ({type}: OneCentAuthorizationLabelProps) => {
  return (
    <NotificationCard
      sx={{
        width: "100%",
        alignItems: "start",
        padding: "12px",
        gap: "4px",
        backgroundColor: Colors.grey._100,
        border: "none",
      }}
    >
      <Container row>
        <IconAlertOutlined width={16} height={16} style={{color: Colors.grey._1000}} />
        <Text fontWeight={"bold"} size={12}>
          Card Verification Required
        </Text>
      </Container>
      {type === "CreditCard" ? (
        <Text size={12}>
          Please be aware that you may see a $0.01 transaction hit your account to validate that your credit card
          information is correct. If successful, the $0.01 transaction will be voided and your payment plan will proceed
          as agreed.
        </Text>
      ) : (
        <Text size={12}>
          Please be aware that you may see a $0.01 transaction hit your account to validate that your debit card
          information is correct. If successful, the $0.01 transaction will be voided and your payment plan will proceed
          as agreed.
        </Text>
      )}
    </NotificationCard>
  );
};
